<template>
	<div v-if="blok.image_link">
		<nuxt-link
			:to="blok.image_link.cached_url"
			class="flex flex-col items-center"
			:class="
				socialMedia
					? 'w-10 h-10 flex justify-center items-center bg-blue rounded-full'
					: ''
			"
			:name="blok.image.title"
		>
			<NuxtImg
				v-if="blok.image.filename"
				:src="blok.image.filename"
				:loading="blok.lazyLoading ? 'lazy' : 'eager'"
				:preload="blok.lazyLoading ? false : true"
				format="webp"
				provider="storyblok"
				:class="`min-h-4 min-w-4 ${extraClasses} max-w-full`"
				:alt="blok.image.alt"
				:width="+storyblokImgDimensions.width"
				:height="+storyblokImgDimensions?.height"
				:fit="socialMedia ? '' : 'in'"
				:placeholder="
					img(
						blok.image.filename,
						{
							width: 10,
							height: 10,
							format: 'webp',
							quality: 50,
							filters: { blur: 2 }
						},
						{ provider: 'storyblok' }
					)
				"
			/>
		</nuxt-link>
	</div>
	<div v-else>
		<NuxtImg
			v-if="blok.image.filename"
			:src="blok.image.filename"
			:loading="blok.lazyLoading ? 'lazy' : 'eager'"
			:preload="blok.lazyLoading ? false : true"
			format="webp"
			provider="storyblok"
			:class="`min-h-4 min-w-4 ${extraClasses} max-w-full`"
			:alt="blok.image.alt"
			:width="+storyblokImgDimensions.width"
			:height="+storyblokImgDimensions?.height"
			fit="in"
			:placeholder="
				img(
					blok.image.filename,
					{
						width: 10,
						height: 10,
						format: 'webp',
						quality: 50,
						filters: { blur: 2 }
					},
					{ provider: 'storyblok' }
				)
			"
		/>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { BlokImage } from "~/types/storyblok/storyblok";

const img = useImage();

interface Props {
	blok: BlokImage;
	extraClasses?: string;
	imageSize?: string;
	socialMedia?: boolean;
}
const { blok, imageSize } = defineProps<Props>();

const storyblokImgDimensions = computed(() => {
	if (imageSize) {
		return { width: imageSize, height: 0 };
	}
	return {
		width: blok.maxWidth,
		height: blok.maxHeight
	};
});
</script>
